import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { Version } from '../../utils/types/versionTypes'
import { buildDateFormat } from '../../utils/helpers/helper'

type Props = {
  version: Version | null
  open: boolean
  onClose: () => void
  onAcknowledge?: () => void
}

const VersionReleaseNotesDialog = ({
  version,
  open,
  onClose,
  onAcknowledge,
}: Props) => {
  if (!version) return null

  const bulletPoints = version.description
    .split(';')
    .map((s) => s.trim())
    .filter(Boolean)

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle fontWeight={700}>
        Release Notes — v{version.version}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {buildDateFormat(version.date, false, true)}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <List dense>
          {bulletPoints.map((point, idx) => (
            <ListItem key={idx} disableGutters>
              <ListItemIcon sx={{ minWidth: 28 }}>
                <FiberManualRecordIcon
                  sx={{ fontSize: 8, color: 'primary.main' }}
                />
              </ListItemIcon>
              <ListItemText primary={point} />
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions sx={{ mr: 2, mb: 1 }}>
        {onAcknowledge ? (
          <Button variant="contained" onClick={onAcknowledge}>
            Acknowledge
          </Button>
        ) : (
          <Button variant="contained" onClick={onClose}>
            Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default VersionReleaseNotesDialog
